import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'tutorial-modal',
  templateUrl: 'tutorial-modal.html',
  styleUrls: ['./tutorial-modal.scss'],
})
export class TutorialModal {
  // Data passed in by componentProps
  @Input() title: string;
  @Input() info1: string;
  @Input() info2: string;
  @Input() info3: string;
  @Input() info4: string;
  @Input() info5: string;

  constructor(
    private analytics: AnalyticsService,
    public modalCtrl: ModalController,
  ) {}

  ionViewDidEnter() {
    this.analytics.trackScreen('TutorialModal');
  }

  ngOnInit() {
    console.log('ngOnInit()');
  }

  dismiss() {
    this.analytics.track('qt_team_tutorial_dismiss', {
      ui: true,
    });
    this.modalCtrl.dismiss();
  }
}
